export interface IEnv {
	projectId?: string | null;
	tenantId?: string | null;
	ssoId?: string | null;
	cookieName?: string | null;
	baseUrl?: string | null;
	baseStaticUrl?: string | null;
	baseRoute?: string | null;
	envName?: string | null;
}

export const env: IEnv = {};
